export class Realtime {
  constructor($) {
    this.$ = $;
    this.$el = this.$('.realtime-box');
    if(this.$el.length === 0) {
      return;
    }

    this.loadRealtimePartial();
  }

  loadRealtimePartial() {
  }
}



// WEBPACK FOOTER //
// ./style-guide-extends/js/translator-dashboard/realtime.js